import React from "react";
import styled from "styled-components";
import { Link } from "@mui/icons-material";

const ExternalLinkStyled = styled.a`
    border-bottom: ${({ theme, underline }) =>
        underline === "none" ? "none" : `2px solid ${theme.palette.background.default}`};
    color: ${({ theme }) => theme.palette.primary.main};
    text-decoration: none;
    cursor: pointer;

    &:hover {
        border-bottom: ${({ theme, underline }) =>
            underline === "none" ? "none" : `2px solid ${theme.palette.primary.main}`};
    }
`;

const ExternalLink = ({ href, underline, children }) => {
    return (
        <ExternalLinkStyled
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            underline={underline}
        >
            {children}
            <Link style={{ verticalAlign: "super", fontSize: "13px" }} href={href} />
        </ExternalLinkStyled>
    );
};

export default ExternalLink;
